export default __webpack_public_path__ + "static/media/Seat.01a3bc5b.svg";